import Title from '../components/items/Title'

import code from '../img/code.png'
import db from '../img/db.png'
import mobile from '../img/mobile.png'

import styles from './specialty.module.css'

export default function Specialty() {
  return (
    <section id="Specialty" className={styles.containerSpecialty}>
      <div className={styles.textMobile}>
        <Title title="MINHAS" subTitle="ESPECIALIDADE." />
      </div>
      <div className={styles.specialties}>
        <div className={styles.webSite}>
          <img src={code} alt="Imagem codigo" />
          <h2>WebSite</h2>
          <h5>
            Criações web utilizando HTML, CSS e JavaScript para criar interfaces
            de usuário dinâmicas e responsivas. Além disso, tenho experiência
            com frameworks modernos como React e Angular, o que me permite criar
            aplicações web complexas e altamente interativas.
          </h5>
        </div>
        <div className={styles.crud}>
          <img src={db} alt="Imagem DB" />
          <h2>CRUD</h2>
          <h5>
            Conhecimentos em desenvolvimento back-end, trabalhando com
            linguagens como JavaScript (Node.js), Python e Java. Utilizo
            frameworks como Express.js, Spring e Quarkus para criar APIs
            robustas e escaláveis, garantindo o bom funcionamento das aplicações
            e a segurança dos dados.
          </h5>
        </div>
        <div className={styles.blog}>
          <img src={mobile} alt="Imagem Mobile" />
          <h2>Mobile</h2>
          <h5>
            Desenvolvimento para dispositivos móveis, permitindo criar
            aplicativos móveis rápidamente. Trabalhando com frameworks
            multiplataforma, como React Native. Essas ferramentas me permitem
            criar aplicativos móveis utilizando uma única base de código,
            alcançando assim uma ampla variedade de dispositivos.
          </h5>
        </div>
      </div>
    </section>
  )
}
